'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { AssetHoverPreview } from '#pplx/frontend/apps/ask/canvas-shared/AssetHoverPreview.js';
import { toCanvasAsset } from '#pplx/frontend/apps/ask/canvas-shared/hooks/assetData/threadArtifacts.js';
import { useAssetTypeDescription } from '#pplx/frontend/apps/ask/canvas-shared/useAssetInfo.js';
import React, { useMemo } from 'react';
export const SidebarArtifactHoverPreview = ({ asset, displayName, forceClosed, onContentClick, children }) => {
    const assetTypeLabel = useAssetTypeDescription(asset.asset_type, asset.media_type);
    const previewAsset = useMemo(() => toCanvasAsset(asset), [asset]);
    return (_jsx(AssetHoverPreview, { asset: previewAsset, displayName: displayName, typeLabel: assetTypeLabel, side: "right", widthPx: 320, offsetPx: 0, triggerClassName: "w-full", showHoverCard: true, forceClosed: forceClosed, onContentClick: onContentClick, children: children }));
};
//# sourceMappingURL=SidebarArtifactHoverPreview.js.map